import {
  faTriangleExclamation,
  faCircleExclamation,
  faWifiSlash,
  faServer,
  faMobileSignal,
} from '@fortawesome/pro-solid-svg-icons';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { HoruzProtocolChulakCloseCode } from '@ver.id/libs.internal.horuz';
import { type AbortVariant } from '../types';

export type AbortVariantConfig = {
  icon: IconDefinition;
  iconClass: string;
  bgClass: string;
  titleKey: string;
  subtitleKey: string;
  showRestart: boolean;
  restartKey: string;
};

export function getAbortVariant(errorCode?: number): AbortVariant {
  switch (errorCode) {
    case HoruzProtocolChulakCloseCode.AGENT_CANCEL:
    case HoruzProtocolChulakCloseCode.APP_CANCEL:
      return 'cancel';
    case HoruzProtocolChulakCloseCode.APP_TIMEOUT:
    case HoruzProtocolChulakCloseCode.PROTOCOL_AUTHENTICATION_TIMEOUT_ERROR:
    case HoruzProtocolChulakCloseCode.PROTOCOL_AUTHENTICATION_ERROR:
      return 'timeout';
    case HoruzProtocolChulakCloseCode.AGENT_DISCONNECT:
      return 'networkLoss';
    case HoruzProtocolChulakCloseCode.APP_ERROR:
    case HoruzProtocolChulakCloseCode.APP_INVALID_RESPONSE:
      return 'appUnavailable';
    default:
      return 'techFail';
  }
}

export const abortVariantConfig: Record<AbortVariant, AbortVariantConfig> = {
  cancel: {
    icon: faTriangleExclamation,
    iconClass: 'text-amber-600',
    bgClass: 'bg-amber-100',
    titleKey: 'abort.cancel.title',
    subtitleKey: 'abort.cancel.subtitle',
    showRestart: true,
    restartKey: 'abort.restart',
  },
  techFail: {
    icon: faCircleExclamation,
    iconClass: 'text-destructive',
    bgClass: 'bg-red-100',
    titleKey: 'abort.techFail.title',
    subtitleKey: 'abort.techFail.subtitle',
    showRestart: true,
    restartKey: 'abort.restart',
  },
  timeout: {
    icon: faClock,
    iconClass: 'text-muted-foreground',
    bgClass: 'bg-muted',
    titleKey: 'abort.timeout.title',
    subtitleKey: 'abort.timeout.subtitle',
    showRestart: false,
    restartKey: 'abort.restart',
  },
  networkLoss: {
    icon: faWifiSlash,
    iconClass: 'text-muted-foreground',
    bgClass: 'bg-muted',
    titleKey: 'abort.networkLoss.title',
    subtitleKey: 'abort.networkLoss.subtitle',
    showRestart: true,
    restartKey: 'abort.retry',
  },
  backendDowntime: {
    icon: faServer,
    iconClass: 'text-muted-foreground',
    bgClass: 'bg-muted',
    titleKey: 'abort.backendDowntime.title',
    subtitleKey: 'abort.backendDowntime.subtitle',
    showRestart: true,
    restartKey: 'abort.retry',
  },
  appUnavailable: {
    icon: faMobileSignal,
    iconClass: 'text-muted-foreground',
    bgClass: 'bg-muted',
    titleKey: 'abort.appUnavailable.title',
    subtitleKey: 'abort.appUnavailable.subtitle',
    showRestart: false,
    restartKey: 'abort.retry',
  },
  deliveryModeMismatch: {
    icon: faCircleExclamation,
    iconClass: 'text-destructive',
    bgClass: 'bg-red-100',
    titleKey: 'abort.deliveryModeMismatch.title',
    subtitleKey: 'abort.deliveryModeMismatch.subtitle',
    showRestart: false,
    restartKey: 'abort.restart',
  },
  flowNotConfigured: {
    icon: faCircleExclamation,
    iconClass: 'text-destructive',
    bgClass: 'bg-red-100',
    titleKey: 'abort.flowNotConfigured.title',
    subtitleKey: 'abort.flowNotConfigured.subtitle',
    showRestart: false,
    restartKey: 'abort.restart',
  },
  parentOriginNotAllowed: {
    icon: faCircleExclamation,
    iconClass: 'text-destructive',
    bgClass: 'bg-red-100',
    titleKey: 'abort.parentOriginNotAllowed.title',
    subtitleKey: 'abort.parentOriginNotAllowed.subtitle',
    showRestart: false,
    restartKey: 'abort.restart',
  },
};
